import { state as pageParamsState } from '../store/store.page-params';
import { setNestedProperty } from '../utils/utils.js';
import { isFirstEventFired } from '../utils/utils.tracking';

import EventBus from './service.eventBus';

const TRACKING_EVENT_NAME = 'TrackingEvent';

export type TrackingEventAction = 'click' | 'search' | 'view' | 'submit' | 'upload' | 'impression' | 'start' | 'engage' | 'scroll';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type EventData = { [k: string]: any };

export interface TrackingEvent {
  event: string;
  eventAction: TrackingEventAction;
  eventElement?: string;
  eventResult: string;
  eventNonInteractive: boolean;
  eventName?: string;
  eventData?: EventData;
  isIcoWebcomponent?: boolean;
}

export function sendTrackingEvent(event: TrackingEvent) {
  const category = event.eventElement ? event.eventElement : pageParamsState.category;
  const firstEventFiredKey = event.eventData?.ico?.offerId && event.eventData.ico.offerId !== '' && event.eventData?.ico?.firstEventFiredKey;
  if (firstEventFiredKey && isFirstEventFired(firstEventFiredKey)) {
    event.eventData = {
      ...event.eventData,
      ico: {
        ...event.eventData?.ico,
        eventValueCode: '219F',
      },
    };
  }
  setNestedProperty(event, 'eventElement', category);
  setNestedProperty(event, 'eventData.ico.offerCode', pageParamsState.offerCode);
  setNestedProperty(event, 'eventData.ico.entryPoint', pageParamsState.lnxCode);
  setNestedProperty(event, 'eventData.ico.path', 'kbb_create');
  setNestedProperty(event, 'isIcoWebcomponent', true);
  EventBus.publish(TRACKING_EVENT_NAME, event);
}
